import {
  getCanonicalTeamName,
  getCanonicalTeamRoute,
} from './teamAliases';
import routeSeoData from './routeSeoData';

const categoryRoutes = routeSeoData?.CATEGORY_ROUTES;

if (
  !categoryRoutes
  || typeof categoryRoutes !== 'object'
  || Array.isArray(categoryRoutes)
) {
  throw new TypeError(
    'routeSeoData must export CATEGORY_ROUTES as an object'
  );
}

export const newsSectionRoutes = Object.entries(categoryRoutes).flatMap(
  ([category, routes]) => routes.map(([section, path]) => ({
    category,
    section,
    path,
  }))
);

const normalizeRouteValue = (value) =>
  String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('uk-UA');

export const getSectionRoute = (sectionName, newsOrCategory) => {
  const canonicalTeamRoute = getCanonicalTeamRoute(sectionName);
  const canonicalSectionName = getCanonicalTeamName(sectionName);
  const normalizedSection = normalizeRouteValue(canonicalSectionName);

  if (!normalizedSection) {
    return null;
  }

  if (canonicalTeamRoute) {
    return canonicalTeamRoute;
  }

  const category = typeof newsOrCategory === 'string'
    ? newsOrCategory
    : newsOrCategory?.category;
  const normalizedCategory = normalizeRouteValue(category);
  const matches = newsSectionRoutes.filter(
    (entry) => normalizeRouteValue(entry.section) === normalizedSection
  );

  if (normalizedCategory) {
    const categoryMatch = matches.find(
      (entry) => normalizeRouteValue(entry.category) === normalizedCategory
    );

    if (categoryMatch) {
      return categoryMatch.path;
    }
  }

  const uniqueRoutes = [...new Set(matches.map((entry) => entry.path))];
  return uniqueRoutes.length === 1 ? uniqueRoutes[0] : null;
};

export default newsSectionRoutes;
